<template>
    <div
        class="col-12 mb-2 pb-2 border-bottom d-flex flex-row"
        :class="{'mt-3': index!==0}"
    >
        <div class="fs-3">
            {{ $t('stockCharge.product')}} {{index + 1}}
        </div>
        <div class="text-end ms-auto">
            <button
                class="btn close btn-danger fs-3 lh-1"
                v-if="index!==0"
                @click.prevent="$emit('removeItem', index)"
            >&times;</button>
        </div>
    </div>

    <!-- product_id -->
    <div class="col-md-6">
        <div class="form-group mb-3">
            <label for="product_id">
                {{ $t('stockCharge.product') }}
            </label>

            <SearchableSelect
                :options="products"
                v-model:modelValue="productId"
            />

            <form-error v-if="errors.product_id" class="d-block">
                {{ errors.product_id }}
            </form-error>
        </div>
    </div>

    <!-- size_id -->
    <div class="col-md-6">
        <div class="form-group mb-3">
            <label for="size_id">
                {{ $t('stockCharge.size') }}
            </label>
            <select
                id="size_id"
                v-model="sizeId"
                class="form-select"
                :class="[errors.size_id ? 'is-invalid' : '']"
            >
                <DefaultOptionElement />
                <option
                    v-for="size in getProductSizes(productId)"
                    :key="size.id"
                    :value="size.id"
                >{{ size.size }}</option>
            </select>
            <form-error v-if="errors.size_id">
                {{ errors.size_id }}
            </form-error>
        </div>
    </div>

    <!-- quantity -->
    <div class="col-md-6">
        <div class="form-group mb-3">
            <label for="quantity">
                {{ $t('stockCharge.quantity') }}
            </label>
            <input
                type="number"
                id="quantity"
                v-model="quantity"
                class="form-control"
                :class="[errors.quantity ? 'is-invalid' : '']"
                min="1"
            >
            <form-error v-if="errors.quantity">
                {{ errors.quantity }}
            </form-error>
        </div>
    </div>
</template>

<script setup lang="ts">
import DefaultOptionElement from "@/components/elements/DefaultOptionElement.vue";
import FormError from "@/components/elements/FormError.vue";
import SearchableSelect from "@/components/elements/SearchableSelect.vue";
import {computed} from "vue";
import type {SizeInterface} from "@/components/helpers/Interfaces.ts";

interface ErrorsInterface {
    product_id?: string,
    size_id?:string,
    quantity?: string
}

const emitter = defineEmits<{
    (e: 'update:productIdModel', value: number)
    (e: 'update:sizeIdModel', value: number)
    (e: 'update:quantityModel', value: number)
    (e: 'removeItem', value: number)
}>()

const {productIdModel, sizeIdModel, quantityModel, errors, products, sizes, index} = defineProps<{
    productIdModel: number,
    sizeIdModel: number,
    quantityModel: number,
    errors: ErrorsInterface,
    products: any,
    sizes: Pick<SizeInterface, 'id' | 'size' | 'product_id'>[],
    index: number
}>()

const productId = computed({
    get() {
        return productIdModel
    },
    set(newValue: number) {
        emitter('update:productIdModel', newValue)
    }
})

const sizeId = computed({
    get(){
        return sizeIdModel;
    },
    set(newValue: number) {
        emitter('update:sizeIdModel', newValue)
    }
})

const quantity = computed({
    get(){
        return quantityModel;
    },
    set(newValue: number) {
        emitter('update:quantityModel', newValue)
    }
})

const getProductSizes = computed(() => {
    return (product_id: number) => {
        if (!product_id) {
            return []
        }

        return sizes.filter(item => item.product_id === product_id)
    }
})
</script>

<style scoped>

</style>
